module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("如何提 issue")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("使用本项目意味着你也有义务帮助其变得更好。")])]), _vm._v(" "), _c('p', [_vm._v("不要浪费维护者时间。")]), _vm._v(" "), _c('p', [_vm._v("不要让维护者帮你学习"), _c('code', [_vm._v("Vue")]), _vm._v("，帮你熟悉"), _c('code', [_vm._v("vue-loader")]), _vm._v("，甚至帮你写代码。")]), _vm._v(" "), _c('p', [_vm._v("不要认为随便一句话就能让维护者明白你的意思，我们没有你想象的那么厉害。")]), _vm._v(" "), _c('p', [_vm._v("不要提没有任何意义的、代码中带有业务逻辑不方便重现的Issue。")]), _vm._v(" "), _c('p', [_vm._v("直接关闭你的"), _c('code', [_vm._v("issue")]), _vm._v("不是对你不满，是你提问题方式不对，没有必要再浪费时间说明为什么要关闭你的"), _c('code', [_vm._v("issue")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("马虎的提问，缺少上下文和重现步骤是在浪费彼此时间。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0af6e143", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-0af6e143"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/issue-153.vue
// module id = 2462
// module chunks = 534